<template>
  <div style="position:relative">
    <div class="filter-area">
      <data-form
        ref="dataForm"
        :content="content"
        :colnum="6"
        :fixedLabelWidth="true"
        :data="formData"
      >
      </data-form>
      <a-button type="primary" @click="search">查询</a-button>
    </div>
    <a-tabs v-model="activeKey" @change="tabChange">
      <a-tab-pane tab="全部订单" key=""></a-tab-pane>
      <a-tab-pane tab="用餐" key="1"></a-tab-pane>
      <a-tab-pane tab="结账" key="2"></a-tab-pane>
      <a-tab-pane tab="反结" key="12"></a-tab-pane>
      <a-tab-pane tab="取消" key="4"></a-tab-pane>
      <a-tab-pane tab="预订" key="0"></a-tab-pane>
      <a-tab-pane tab="待确认" key="13"></a-tab-pane>
    </a-tabs>
    <data-grid
      ref="dataGrid"
      :columns="columns"
      api="GetOrderPageAsync"
      v-model="data"
      :params="params"
      :pagination="true"
      :props="props"
      bordered
    >
      <template slot="rowAction" slot-scope="text, record">
        <a-button
          type="link"
          size="small"
          v-if="record.Status == 0 || record.Status == 13"
          @click="editOrder(text)"
          >修改</a-button
        >
        <a-divider type="vertical" v-if="record.Status == 13" />
        <a-button
          type="link"
          size="small"
          v-if="record.Status == 13"
          @click="confirmOrder(text)"
          >确认</a-button
        >
        <a-divider
          type="vertical"
          v-if="record.Status == 0 || record.Status == 13"
        />
        <a-popconfirm
          title="确定取消订单吗?"
          ok-text="确定"
          cancel-text="取消"
          v-if="record.Status == 0 || record.Status == 13"
          @confirm="cancelBookingOrder(record.Id)"
        >
          <a-button type="link" size="small">取消</a-button>
        </a-popconfirm>
        <a-button
          type="link"
          size="small"
          v-if="record.Status == 1"
          @click="cancelOrder(text)"
          >取消</a-button
        >

        <a-button
          type="link"
          size="small"
          @click="antiSettle(text)"
          v-if="record.Status == 2"
          >反结</a-button
        >
      </template>
    </data-grid>
    <OrderDetail
      ref="OrderDetail"
      @update="reload"
      @antiTable="(id, orderData) => antiSettle(id, orderData, true)"
      @cancelTable="(id, orderData) => cancelOrder(id, orderData, true)"
    ></OrderDetail>
    <multTableOrder
      ref="multTableOrder"
      :isChooseTable="true"
      @submit="getTableIds"
      title="选择桌台"
    ></multTableOrder>
  </div>
</template>
<script>
import { DataGrid } from "@/components/dataGrid";
import { DataForm } from "@/components/dataForm";
import OrderDetail from "./OrderDetail";
import multTableOrder from "./multTableOrder";
import moment from "moment";
export default {
  components: {
    DataGrid,
    DataForm,
    OrderDetail,
    multTableOrder
  },
  data() {
    return {
      columns: [],
      data: [],
      params: {},
      props: {
        scroll: {
          x: 2200,
          y: "calc(100vh - 300px)"
        }
      },
      activeKey: "",
      content: [
        {
          label: "时间类型",
          type: "select",
          name: "QueryTimeParam",
          data: [
            {
              Id: "1",
              Text: "开台时间"
            },
            {
              Id: "2",
              Text: "结账时间"
            },
            {
              Id: "3",
              Text: "账务日期"
            }
          ]
        },
        {
          label: "订单日期",
          type: "date-range-picker",
          name: "dateRange",
          colnum: 2
        },
        {
          label: "联系人",
          name: "Contact"
        },
        {
          label: "手机号",
          name: "Phone"
        },
        {
          label: "订单号",
          name: "No"
        }
      ],
      formData: {},
      orderId: "",
      isCancelOrder: false,
      isInDetail: false
    };
  },
  created() {
    this.columns = [
      {
        title: "序号",
        width: 70,
        align: "center",
        type: "indexcolumn"
      },
      {
        title: "单号",
        width: 100,
        dataIndex: "No",
        customRender: (text, record) => {
          if (text) {
            const orderDetail = {
              click: () => {
                this.orderDetail(record.Id);
              }
            };
            return (
              <a-button type="link" size="small" {...{ on: orderDetail }}>
                {text}
              </a-button>
            );
          }
        }
      },
      {
        title: "桌台",
        width: 170,
        dataIndex: "TableNames"
      },
      {
        title: "人数",
        width: 70,
        dataIndex: "PersonCount"
      },
      {
        title: "状态",
        width: 110,
        dataIndex: "Status",
        customRender: (text, record) => {
          if (text == 1) {
            return <a-badge status="processing" text={record.StatusName} />;
          } else if (text == 2) {
            return <a-badge status="success" text={record.StatusName} />;
          } else if (text == 4) {
            return <a-badge status="error" text={record.StatusName} />;
          } else {
            return <a-badge status="warning" text={record.StatusName} />;
          }
        }
      },
      {
        title: "金额",
        width: 80,
        dataIndex: "Fee",
        align: "right"
      },
      {
        title: "联系人",
        width: 130,
        dataIndex: "Contact"
      },
      {
        title: "电话",
        width: 120,
        dataIndex: "Phone"
      },
      {
        title: "开台时间",
        width: 160,
        dataIndex: "CheckInTime"
      },
      {
        title: "结账时间",
        width: 160,
        dataIndex: "CheckOutTime"
      },
      {
        title: "账务日期",
        width: 130,
        dataIndex: "SettleDate"
      },
      {
        title: "会员名称",
        width: 130,
        dataIndex: "MemberName"
      },
      {
        title: "客户名称",
        width: 130,
        dataIndex: "CustomerName"
      },
      {
        title: "业务员名称",
        width: 130,
        dataIndex: "SalesmanName"
      },
      {
        title: "备注",
        dataIndex: "OrderRemark"
      },
      {
        title: "操作",
        dataIndex: "Id",
        width: 200,
        fixed: "right",
        key: "action",
        align: "left",
        scopedSlots: { customRender: "rowAction" }
      }
    ];
    this.activeKey =
      this.$route.query.activeKey != undefined
        ? this.$route.query.activeKey
        : "";
    this.params = {
      ...this.params,
      OrderStatus: this.activeKey
    };
    if (this.$route.query.orderId) {
      setTimeout(() => {
        this.$refs.OrderDetail.show(this.$route.query.orderId);
        const url = window.location.href.split("?")[0];
        window.history.replaceState(
          {
            path: url
          },
          "",
          url
        );
      }, 500);
    }
  },
  methods: {
    orderDetail(id) {
      // this.$router.push({
      //   name: "RestaurantOrderDetail",
      //   query: {
      //     Id: id
      //   }
      // });
      this.$refs.OrderDetail.show(id);
    },
    tabChange(key) {
      this.params = {
        ...this.params,
        OrderStatus: key
      };
    },
    editOrder(id) {
      this.$router.push({
        name: "RestaurantBookingIndex",
        query: {
          id: id
        }
      });
    },
    confirmOrder(id) {
      const _this = this;
      this.$confirm({
        title: "确定操作吗?",
        onOk() {
          _this.$post("ConfirmBooking", { Id: id }).then(() => {
            _this.$message.success("操作成功 ");
            _this.reload();
          });
        }
      });
    },
    cancelBookingOrder(id) {
      this.$post("Rest_CancelOrder", {
        Id: id
      }).then(() => {
        this.$message.success("取消成功");
        this.reload();
      });
    },
    cancelOrder(id, orderData, isInDetail) {
      this.orderId = id;
      this.isInDetail = isInDetail;
      this.isCancelOrder = true;
      if (orderData) {
        setTimeout(() => {
          this.$refs.multTableOrder.show({}, [], orderData);
        }, 100);
      } else {
        this.$post("Rest_GetOrderDetail", { Id: id }).then(res => {
          const data = res.Data;
          data.DishTables = data.DishTables.filter(el => el.OrderStatus == 1);
          setTimeout(() => {
            if (data.DishTables && data.DishTables.length) {
              this.$refs.multTableOrder.show({}, [], data);
            } else {
              this.$message.warning("没有可取消的桌台 ");
            }
          }, 100);
        });
      }
    },
    antiSettle(id, orderData, isInDetail) {
      this.isInDetail = isInDetail;
      this.isCancelOrder = false;
      this.orderId = id;
      if (orderData) {
        setTimeout(() => {
          this.$refs.multTableOrder.show({}, [], orderData);
        }, 100);
      } else {
        this.$post("Rest_GetOrderDetail", { Id: id }).then(res => {
          const data = res.Data;
          data.DishTables = data.DishTables.filter(el => el.OrderStatus == 2);
          setTimeout(() => {
            this.$refs.multTableOrder.show({}, [], data);
          }, 100);
        });
      }
    },
    getTableIds(ids) {
      if (this.isCancelOrder) {
        this.$post("Rest_CancelOrder", {
          Id: this.orderId,
          TableIds: ids
        }).then(() => {
          this.$message.success("取消成功");
          if (this.isInDetail) {
            this.$refs.OrderDetail.getDetail();
          } else {
            this.reload();
          }
          this.$refs.multTableOrder.onCancel();
        });
      } else {
        this.$post("RMS_AntiSettle", {
          OrderId: this.orderId,
          TableIds: ids
        }).then(() => {
          this.$message.success("操作成功");
          if (this.isInDetail) {
            this.$refs.OrderDetail.getDetail();
          } else {
            this.reload();
          }
          this.$refs.multTableOrder.onCancel();
        });
      }
    },
    reload() {
      this.$refs.dataGrid.reload();
    },
    search() {
      const formData = this.$refs.dataForm.getData();
      let values = { ...formData };
      if (formData.dateRange) {
        values.StartDate = formData.dateRange[0]
          ? moment(formData.dateRange[0]).format("YYYY-MM-DD")
          : "";
        values.EndDate = formData.dateRange[1]
          ? moment(formData.dateRange[1]).format("YYYY-MM-DD")
          : "";
      }
      values.OrderStatus = this.activeKey;
      delete values.dateRange;
      this.params = {
        ...values
      };
    }
  }
};
</script>

<style lang="less" scoped>
.filter-area {
  // position: absolute;
  // right: 0px;
  // top: 0;
  z-index: 10;
  display: flex;
  width: 1250px;
  /deep/.data-form-box .fixed-label-width .ant-form-item .ant-form-item-label {
    width: 80px;
  }
  button {
    margin-left: 10px;
    margin-top: 3px;
  }
}
</style>
